import { Checkbox } from "primereact/checkbox";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import React from "react";
import { Calendars } from "../../../components/Calendar/Calendar";
import { validateInputText } from "../../../utilities/ValidateUtil";

export default function P231Search({ data, dataHead, setDataHead, submitted }) {
    const onInputTextChange = (e, key) => {
        let val = (e.target && e.target.value) || "";
        let type = (e.target && e.target.type) || "";

        if (type === "checkbox") {
            if (!e.target.checked) {
                val = "N";
            }
        }
        if (key === "dayDelay") {
            console.log("val ", val.leanth);
        }
        setDataHead({
            ...dataHead,
            [`${key}`]: val,
        });
    };

    const handleKeyDown = (e) => {
        const typedNumber = parseInt(e.key);
        const max = parseInt(e.target.max);
        const currentVal = parseInt(e.target.value) || "";
        const newVal = parseInt(typedNumber.toString() + currentVal.toString());

        if (newVal > max) {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    //Header
    const renderHead = () => {
        return (
            <>
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col-12 p-md-4">
                        <label>เลขที่สัญญา</label>
                        <InputText type="text" placeholder="เลขที่สัญญา" disabled maxLength="20" value={data.contractNo} />
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <label>เส้นทาง</label>
                        <InputText type="text" placeholder="เส้นทาง" disabled maxLength="200" value={data.routeNo} />
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <label>ครั้งที่</label>
                        <InputText type="text" placeholder="ครั้งที่" disabled maxLength="2" value={data.deliverNo} />
                    </div>
                </div>
                <hr />
            </>
        );
    };

    return (
        <>
            {renderHead()}

            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-4">
                    <label>ผู้รับจ้าง</label>
                    <InputText type="text" placeholder="ผู้รับจ้าง" disabled maxLength="200" value={dataHead.contractorName} />
                </div>
                <div className="p-field p-col-12 p-md-4">
                    <label>หนังสือส่งมอบงานเลขที่</label>
                    <InputText type="text" placeholder="หนังสือส่งมอบงานเลขที่" value={dataHead.letterNo} className="p-invalid" onChange={(e) => onInputTextChange(e, "letterNo")} autoFocus />
                    {submitted && !dataHead.letterNo && validateInputText("letterNo", "หนังสือส่งมอบงานเลขที่")}
                </div>

                <div className="p-field p-col-12 p-md-4">
                    <label>ลงวันที่</label>
                    <Calendars
                        maxLength="10"
                        placeholder="ลงวันที่"
                        key="letterDate"
                        id="letterDate" //2021-04-05
                        inputClassName="p-invalid"
                        // value={new Date(dataHead.letterDate)}
                        value={dataHead.letterDate}
                        // value={obj.letterDate}
                        onChange={(e) => onInputTextChange(e, "letterDate")}
                    />
                    {submitted && !dataHead.letterDate && validateInputText("letterDate", "ลงวันที่")}
                </div>
            </div>

            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-4">
                    <label>สถานที่</label>
                    <InputText type="text" placeholder="สถานที่" disabled maxLength="200" value={dataHead.siteLocation} />
                </div>
                <div className="p-field p-col-12 p-md-4">
                    <label>วันที่เริ่มงานตามสัญญา</label>
                    <InputText type="text" placeholder="วันที่เริ่มงานตามสัญญา" disabled maxLength="20" value={dataHead.contractBeginDate} />
                </div>
                <div className="p-field p-col-12 p-md-4">
                    <label>กำหนดแล้วเสร็จ</label>
                    <InputText type="text" placeholder="กำหนดแล้วเสร็จ" disabled maxLength="20" value={data.contractEndDate} />
                </div>
            </div>

            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-4">
                    <label>ระยะเวลาก่อสร้าง</label>
                    <Calendars
                        maxLength="10"
                        placeholder="ระยะเวลาก่อสร้าง"
                        key="deliverBeginDate"
                        id="deliverBeginDate"
                        inputClassName="p-invalid"
                        // value={new Date(dataHead.deliverBeginDate)}
                        value={dataHead.deliverBeginDate}
                        onChange={(e) => onInputTextChange(e, "deliverBeginDate")}
                    />
                    {submitted && !dataHead.deliverBeginDate && validateInputText("deliverBeginDate", "ระยะเวลาก่อสร้าง")}
                </div>
                <div className="p-field p-col-12 p-md-4">
                    <label>ถึง</label>
                    <Calendars
                        maxLength="10"
                        placeholder="ถึง"
                        key="deliverEndDate"
                        id="deliverEndDate"
                        inputClassName="p-invalid"
                        // value={new Date(dataHead.deliverEndDate)}
                        value={dataHead.deliverEndDate}
                        onChange={(e) => onInputTextChange(e, "deliverEndDate")}
                    />
                    {submitted && !dataHead.deliverEndDate && validateInputText("deliverEndDate", "ระยะเวลาก่อสร้าง ถึง")}
                </div>
                <div className="p-field p-col-12 p-md-4">
                    <label>งานล่าช้า</label>
                    <InputNumber placeholder="งานล่าช้า" inputId="dayDelay" value={dataHead.dayDelay} onValueChange={(e) => onInputTextChange(e, "dayDelay")} mode="decimal" max={999} onKeyDown={handleKeyDown} useGrouping={true} />
                </div>
            </div>

            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-4">
                    <label>อัตราค่าปรับ</label>
                    <div className="p-inputgroup">
                        <InputNumber placeholder="อัตราค่าปรับ" inputId="fineRate" value={dataHead.fineRate} disabled mode="decimal" className="p-component" />
                        <span className="p-inputgroup-addon p-component" style={{ width: 100 }}>
                            บาท/วัน
                        </span>
                    </div>
                </div>
                <div className="p-field p-col-12 p-md-4">
                    <label>รวมค่าปรับ</label>
                    <div className="p-inputgroup">
                        <InputNumber
                            placeholder="รวมค่าปรับ"
                            inputId="fineRate"
                            value={dataHead.fineAmount}
                            max={999999999999999}
                            minFractionDigits={2}
                            maxFractionDigits={2}
                            // minFractionDigits={2}
                            // maxFractionDigits={99}
                            onValueChange={(e) => onInputTextChange(e, "fineAmount")}
                            mode="decimal"
                            className="p-component"
                        />
                        <span className="p-inputgroup-addon p-component" style={{ width: 100 }}>
                            บาท/วัน
                        </span>
                    </div>
                </div>
            </div>

            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-3">
                    <label>ตรวจรับวันที่</label>
                    <Calendars
                        maxLength="10"
                        placeholder="ตรวจรับวันที่"
                        key="meetingDate"
                        id="meetingDate"
                        inputClassName="p-invalid"
                        // value={new Date(dataHead.meetingDate)}
                        value={dataHead.meetingDate}
                        onChange={(e) => onInputTextChange(e, "meetingDate")}
                    />
                    {submitted && !dataHead.meetingDate && validateInputText("meetingDate", "ตรวจรับวันที่")}
                </div>
            </div>

            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-3">
                    <label></label>
                    <div className="p-field-checkbox">
                        <Checkbox inputId={"finalFlag"} name={"finalFlag"} value="Y" checked={dataHead.finalFlag === "Y"} onChange={(e) => onInputTextChange(e, "finalFlag")} />
                        <label>ส่งงานครั้งสุดท้าย</label>
                    </div>
                </div>
            </div>

            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-12 p-md-8">
                    <label>หมายเหตุ</label>
                    <InputText type="text" placeholder="หมายเหตุ" maxLength="200" value={dataHead.remark} onChange={(e) => onInputTextChange(e, "remark")} />
                </div>
            </div>
        </>
    );
}
